export default {
  path: '/t/:code',
  name: 'traceScan',
  meta: { title: '防伪追溯', public: true },
  component: () => import('@/views/trace/public/ScanPage'),
}
